import React from "react";
import "./CancelConfirmationCard.css";

const CancelConfirmationCard = ({ isVisible, onConfirm, onCancel }) => {
  if (!isVisible) return null;

  return (
    <div className="cancel-confirmation-overlay" onClick={onCancel}>
      <div
        className="cancel-confirmation-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cancel-confirmation-header">
          <h3>Cancel Subscription</h3>
        </div>
        <div className="cancel-confirmation-body">
          <p>Are you sure you want to cancel your subscription?</p>
        </div>
        <div className="cancel-confirmation-footer">
          <button
            className="cancel-confirmation-btn cancel-btn"
            onClick={onCancel}
          >
            Keep Subscription
          </button>
          <button
            className="cancel-confirmation-btn confirm-btn"
            onClick={onConfirm}
          >
            Yes, Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelConfirmationCard;
